// extracted by mini-css-extract-plugin
export default {"sizeThreeQuarters":"sizeThreeQuarters-Ng20s","size1x":"size1x-O6Ult","size1Quarter":"size1Quarter-hdKQz","size1Half":"size1Half-s_kQ1","size2x":"size2x-WNafe"};